import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Home } from './pages/Home';
import { Donations } from './pages/Donations';
import { Accommodation } from './pages/Accommodation';
import TemplePoojas from './pages/templepoojas';
import BookDarshan from './pages/bookdarshan';
import AdminPage from "./admin/admin";
import { Gallery } from "./pages/Gallery";
import AdminLogin from "./components/AdminLogin";
import AdminSignup from "./components/AdminSignup";
import { Community } from './pages/Community';
import AboutTemple from './pages/AboutTemple';
import { useState } from 'react';

function App() {
  const [showEventCalendar, setShowEventCalendar] = useState(false);

  const toggleEventCalendar = () => setShowEventCalendar(!showEventCalendar);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <Home showEventCalendar={showEventCalendar} toggleEventCalendar={toggleEventCalendar} />
            }
          />
          <Route path="/templepoojas" element={<TemplePoojas />} />
          <Route path="/donations" element={<Donations />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/bookdarshan" element={<BookDarshan />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-signup" element={<AdminSignup />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/community" element={<Community />} />
          {/* <Route path="/about" element={<AboutTemple />} /> */}
          {/* 404 Fallback Route */}
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center bg-orange-50">
              <div className="text-center p-8">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">404 - Page Not Found</h1>
                <p className="text-lg text-gray-600 mb-6">The page you're looking for doesn't exist.</p>
                <NavLink
                  to="/"
                  className="inline-block bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition-all duration-300"
                >
                  Go Home
                </NavLink>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

